export default __webpack_public_path__ + "static/investor-logos-96624abfba0189ad15390497ae5d2695.png";